// UI texts: workshop
export default {
  /** Package 4, part A: before crafting opens (a new account's first week). */
  closedTitle: 'The Workshop is not set up yet',

  title: 'Workshop',
  lv: 'LV {n}',
  back: 'Back to camp',
  /** 1. 10. 2026: the header with the building and its next level (was the tool illustration and the upgrade card). */
  header: {
    /** 6. 10. 2026 (Workshop 1): "WORKSHOP LV 5/5 · up to Epic · 20% faster"; jobs at once and places only in the queue strip. */
    upTo: 'up to {rarity}',
    faster: '{n}% faster',
    next: 'Next: LV {n}',
  },
  blueprint: 'Blueprint · {group}',
  no: 'No. {n}',
  craftTime: 'Craft time',
  /** Krug 5 (K4.7): what INT does for a recipe. */
  intCut: '−{n}% materials (INT)',
  intRoll: 'Rolls at least {n}%',
  xp: '+{n} XP',
  makes: 'Makes ×{n}',
  craft: 'Craft · {time}',
  /** Krug 5 (K7.3): the item's expected PWR and range before it is made. */
  pwrRange: 'PWR ~{n} ({lo}–{hi})',
  /** 1. 10. 2026: when every test craft lands on the same number. */
  pwrOne: 'PWR {n}',
  vsEquipped: '{d} vs equipped',
  emptySlot: 'Empty slot',
  pwrTip: 'The middle of 200 test crafts at your level and INT, with the range 8 in 10 of them land in',
  /** How many at once (26. 9. 2026): one job each in the queue. */
  craftN: 'Craft {n} times · {time}',
  amount: 'Amount',
  amountMax: 'max {n}',
  amountLess: 'One less',
  amountMore: 'One more',
  timeEach: '{n} × {each}',
  queuedN: '{name}: {n} jobs on the bench',
  missing: 'Missing {what}',
  needsWs: 'Needs Workshop Lv {n}',
  queueFull: 'Queue full',
  queued: '{name} is on the bench',
  queue: 'Queue',
  upgradeJob: 'Upgrade: {name}',
  /** 1. 10. 2026 (C4): "Tier upgrade: Reinforced Crowbar → T3". */
  tierUpJob: 'Tier upgrade: {name}',
  slots: '{n}/{max} slots',
  /** 30. 9. 2026: two jobs at once from Workshop 3, three from 5. */
  atOnce: '{n} at once',
  onBench: 'On the bench',
  waits: 'waits · {time}',
  idle: 'Bench is idle.',
  cancel: 'Cancel {name} and refund the resources',
  refunded: 'Canceled. Resources are back in Storage.',
  unlocked: '{n}/{total} unlocked',
  ready: 'ready',
  short: 'missing',
  /** The only lock on a recipe is the Workshop level (B4); survivor level never locks one. */
  locked: 'Workshop Lv {n}',
  empty: 'No recipes on the wall yet.',
  /** Krug 5 (K12.11): the consumables as Meals and Supplies; Campfire's cut on a meal's Food. */
  groups: { meals: 'Meals', supplies: 'Supplies' },
  campfire: '−{n}% Food (Campfire)',
  /** 4. 10. 2026 (package 3, K): the Workshop of the mockups 3b–3h. */
  top: {
    lvShort: 'LV {n}/{max}',
    upgradeShort: 'LV {n} · {k} resources short',
    upgradeShortOne: 'LV {n} · 1 resource short',
    upgradeReady: 'LV {n} · ready to build',
    upgrading: 'LV {n} · building',
    /** 6. 10. 2026 (Workshop 4): a label, no arrow and nothing to open. */
    max: 'Max level',
  },
  /** 6. 10. 2026 (Workshop 2): the queue as one strip, a small bench for each job that runs at once. */
  strip: {
    queue: 'Queue {n}/{max}',
    atOnce: '{n} jobs at once',
    empty: 'empty',
    waiting: '{n} waiting',
    /** Workshop 9: a batch's piece on its bench, "Canned Feast 1/2". */
    part: '{name} {k}/{n}',
  },
  /** 6. 10. 2026 (Workshop 3): Storage in the header on every tab; the materials of the recipe picked are marked. */
  res: {
    label: 'Storage',
    have: '{name}: {have} in Storage',
    need: '{name}: {have} in Storage, the recipe needs {need}',
  },
  /** 6. 10. 2026 (Workshop 9): a batch on several benches in the queue card. */
  batch: {
    onBenches: '{n} on benches',
    waiting: '{n} waiting',
    done: '{n} done',
    cancel: 'Cancel all of {name} and refund the resources',
    cancelPiece: 'Cancel {name} {k}/{n} and refund its resources',
  },
  /** The order of the waiting jobs in the queue card. */
  next: 'Next',
  /** 6. 10. 2026: what is known before crafting, against what is worn (recipe detail, Blueprint candidates). */
  vsWorn: {
    title: 'VS worn',
    empty: 'Empty slot',
    main: '{stat} {mine} vs {theirs}, {d}',
    mainEmpty: '{stat} {mine}',
    wornAffix: 'worn has {n} affix on top',
    perkLabel: 'Perk',
    perk: '{mine} vs {theirs}',
    noPerk: 'no perk',
    loadLabel: 'Load',
    setLabel: 'Set',
    affixes: '{n} random affixes',
    affix1: '1 random affix',
    noAffixes: 'No affixes',
  },
  inLine: '#{n}',
  tabs: { gear: 'Gear', supplies: 'Supplies', relic: 'Relic Forge', recalibrate: 'Recalibrate' },
  /** 11. 10. 2026 (BACKLOG #36): the Recalibrate tab. */
  recal: {
    intro: 'Change one affix of an item for a new random one, for Relic Shards and the item’s own materials. From then on only that affix of the item can change, and each time costs {x}× the time before.',
    locked: 'Recalibrate opens at Workshop {n}.',
    empty: 'No item with affixes in Storage or worn.',
    pick: 'Pick an item.',
    worn: 'Worn',
    items: 'Items {n}',
  },
  gear: {
    recipes: 'Recipes {n}/{total}',
    showing: 'showing {n}',
    canCraftNow: 'Can craft now',
    sort: 'Sort',
    sortUpgrades: 'Upgrades first',
    sortSlot: 'By slot',
    upgrades: 'Upgrades for you',
    /** 7. 10. 2026: Upgrades first on All when no recipe beats what is worn. */
    noUpgrades: 'No upgrades right now. Closest first below.',
    count: '{n} recipes',
    countOne: '1 recipe',
    /** 6. 10. 2026 (Workshop 7): one slot sorts itself. */
    sortedPwr: 'Sorted by PWR vs worn',
    sortedCapacity: 'Sorted by capacity',
    sortedAccessory: 'Sorted by PWR',
    colTier: 'Tier',
    colRarity: 'Rarity',
    colTime: 'Time',
    colVs: 'vs worn',
    colStatus: 'Status',
    statusReady: 'ready',
    statusMissing: 'missing',
    statusWs: 'WS {n}',
    statusLevel: 'Lv {n}',
    statusQueue: 'queue full',
    vsPwr: '{d} PWR',
    emptySlot: 'empty slot',
    none: 'No recipe fits these filters.',
    noRecipes: 'No gear recipes yet. Use a Blueprint from Storage to learn one.',
    recipeOf: '{slot} · T{tier} recipe',
    rarity: 'Rarity',
    onTier: 'Crafts on your tier',
    materials: 'Materials',
    upTo: 'Your recipe goes up to {rarity}. A better Blueprint raises it.',
    pickRarity: 'Pick a rarity',
    wearAt: 'You can wear it from level {n}.',
    learnMore: 'Recipes come from Blueprints. Use them in Storage.',
    all: 'All',
    slots: { weapon: 'Weapon', helmet: 'Head', body: 'Body', gloves: 'Hands', pants: 'Legs', boots: 'Feet', backpack: 'Pack', accessory: 'Accessory' },
  },
  supplies: {
    groups: { food: 'Food', medical: 'Medical', ammo: 'Ammo & Repair' },
    count: '{n} recipes',
    inStorage: 'in storage',
    each: '{cost} · {time} each',
    note: 'A batch takes one place in the queue and runs on every free bench. Supplies use the same queue as gear.',
    batch: '×{n}',
    batchTip: 'Craft {n}: {cost}, {time}',
    locked: 'Workshop Lv {n}',
    /** 23. 10. 2026 (owner): an Ammo recipe without a firearm. */
    needsFirearm: 'Needs a firearm, worn or in Storage',
    /** Package 4, part O: meals follow the survivor's tier. */
    mealTier: 'T{tier} version: more Food on a higher tier, a little stronger',
    /** 6. 10. 2026: "Bandage ×6 added to the queue." */
    queued: '{what} added to the queue.',
  },
  forge: {
    shards: 'Relic Shards',
    about: 'One forge costs {n} shards and rolls three Legendary items on your tier. You keep one.',
    aboutDiscount: 'Your Relic Discount: this forge costs {n} shards instead of {full}.',
    /** Package 4, part E (owner's text): what a forged item is. */
    bound: "Forged items are bound to you: they can never be traded. If one is taken in a fight, win it back within 24 h or it breaks.",
    pick: 'Pick 3 slots',
    pickHint: 'the same slot can be picked more than once',
    slot: 'Slot {n}',
    weaponClass: 'Weapon class',
    classes: { melee_1h: 'Melee 1H', melee_2h: 'Melee 2H', ranged_1h: 'Ranged 1H', ranged_2h: 'Ranged 2H' },
    slotShort: { weapon: 'Weapon', helmet: 'Head', body: 'Body', gloves: 'Hands', pants: 'Legs', boots: 'Feet', backpack: 'Pack', accessory: 'Access.' },
    poolLine: '{n} on your tier · {m} not in your book',
    forge: 'Forge · {n} shards',
    short: '{n} shards short',
    needsWs: 'The forge needs Workshop Lv {n}.',
    rollsHint: 'Rolls 3 Legendary candidates. Choose one, then it crafts for {time}.',
    choose: 'Choose one',
    shownOnTier: 'Stats shown on your tier T{n}. The other two are lost.',
    saved: 'Candidates are saved. You can choose later.',
    chooseBtn: 'Choose · {time}',
    vsEquipped: '{d} vs equipped',
    powerNow: 'Your Power {from} → {to}',
    newInBook: 'New in your book',
    forging: 'Forging {name}',
    forgingHint: 'In the Workshop queue. Cancel it there to choose again.',
    rolled: 'Three candidates are waiting for you.',
    chosen: '{name} is on the bench.',
    sources: 'Shards come from dismantling Epic gear (1–2), the weekly contract (10), the Sunday boss (6+), Survivor Rank boxes and risky choices that pay off.',
  },
  reworkJob: '{name}',
  relic: {
    title: 'Relic forge',
    cost: '{n} Relic Shards',
    pick: 'Forge the Legendary of any item you have found in Epic: {n} on the list under Relic forge.',
    none: 'Find any item in Epic and its Legendary shows up here.',
    needsWs: 'The forge needs Workshop Lv {n}.',
    sources: 'Shards come from dismantling Epic gear (1–2), the weekly contract (10), the Sunday boss (6+) and risky choices that pay off.',
    bound: "Bound to you: it can never be traded. If it's taken in a fight, win it back within 24 h or it breaks.",
    /** 1. 10. 2026 (C4): the Forge makes the Legendary on the survivor's tier (the warning "outclassed" is gone). */
    onTier: 'Forged on your tier: T{n}',
  },
} as const;
